/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Emptycoursesdescription2Inputs */

const zh_course_emptycoursesdescription2 = /** @type {(inputs: Course_Emptycoursesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程可以帮助你像教材一样组织学习资料`)
};

const en_course_emptycoursesdescription2 = /** @type {(inputs: Course_Emptycoursesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Courses help you organize study materials like a textbook`)
};

const es_course_emptycoursesdescription2 = /** @type {(inputs: Course_Emptycoursesdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cursos te ayudan a organizar materiales de estudio como un libro de texto`)
};

/**
* | output |
* | --- |
* | "Courses help you organize study materials like a textbook" |
*
* @param {Course_Emptycoursesdescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_emptycoursesdescription2 = /** @type {((inputs?: Course_Emptycoursesdescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Emptycoursesdescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_emptycoursesdescription2(inputs)
	if (locale === "en") return en_course_emptycoursesdescription2(inputs)
	return es_course_emptycoursesdescription2(inputs)
});
export { course_emptycoursesdescription2 as "course_emptyCoursesDescription" }